<template>
  <div class="fixed-top bg-light topbar" v-if="!hideTop">
    <div class="container-fluid">
      <div class="row py-1 justify-content-between align-items-center">
        <div class="col-8 col-md-4">
          <div class="d-flex align-items-center" style="padding: 4px 0">
            <div class="mr-3" v-if="dados">
              <img :src="dados.business_logo || 'https://img.freepik.com/vetores-premium/icone-do-robo-design-de-sinal-de-bot-conceito-de-simbolo-de-chatbot-servico-de-suporte-por-voz-bot-bot-de-suporte-on-line-estoque-ilustracao-vetorial_100456-34.jpg'" class="img-perfil">
            </div>
            <h6 class="mb-0 w-100 text-ellipsis">{{dados.business_name}}</h6>
          </div>
        </div>
        <div class="col-4 py-2 text-right d-md-none">
          <a href="javascript:" class="text-dark" @click="menu = !menu">
            <img src="../assets/icons/square.svg" style="width: 36px" alt="Menu">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Modal from "@/components/Modal";
  export default {
    name: 'TopBar',
    components: {Modal},
    props: ['hideTop'],
    data() {
      return {
        load: true,
        menu: false,
        deferredPrompt: null,
        showNotification: false
      }
    },

    computed: {
      dados() {
        return this.$store.state.dataUser
      }
    },

    created() {
      this.$parent.$on('toggleMenu', () => {
        this.menu = true;
      });
    }
  }
</script>
<style scoped>
.img-perfil {
  max-width: 40px;
  border-radius: 50%;
  object-fit: cover;
}
</style>